<template>
  <div class="apply scroll-bar" 
          :style="{marginBottom:!phoneFlag?'50px':'20px'}">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      label-position="top"
      size="small"
    >
      <div class="person-info" style="margin-bottom: 20px">
        <h4
          :hidden="!this.ruleForm.canSubmit"
          style="padding-bottom: 10px; color: red"
        >
          {{ $t("app.applicationDescription") }}
        </h4>
        <h3>{{ $t("app.personalInfo") }}</h3>
        <el-divider></el-divider>
        <el-form-item :label="$t('app.statement')" prop="declare" ref="declare">
          <el-checkbox
            class="phoneCheckbox"
            :style="!phoneFlag ? { whiteSpace: 'pre-wrap' } : {}"
            v-model="ruleForm.declare"
            >{{ $t("app.applyView.statementMSG") }}</el-checkbox
          >
          <el-link
            type="primary"
            href="https://www.utm.edu.mo/Hostel/"
            target="_blank"
            :underline="false"
            style="max-width: 100%"
          >
          &nbsp;&nbsp;https://www.utm.edu.mo/Hostel/
          </el-link>
        </el-form-item>
        <el-col :span="12" style="height: 85px">
          <el-form-item
            :label="$t('app.applicationNumber')"
            prop="applyCode"
            ref="applyCode"
          >
            <el-input v-model="ruleForm.applyCode" :disabled="true"></el-input>
          </el-form-item>
        </el-col>
        <el-col
          :xs="24"
          :sm="12"
          :md="12"
          :lg="12"
          :xl="12"
          style="height: 85px"
        >
          <el-form-item :label="$t('app.gender')" prop="gender" ref="gender">
            <el-input v-model="ruleForm.gender" :disabled="true"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
          <el-form-item
            :label="$t('app.surname')"
            prop="nameFirst"
            ref="nameFirst"
          >
            <el-input v-model="ruleForm.nameFirst" :disabled="true"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
          <el-form-item
            :label="$t('app.firstName')"
            prop="nameSecond"
            ref="nameSecond"
          >
            <el-input v-model="ruleForm.nameSecond" :disabled="true"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
          <el-form-item :label="$t('app.chineseName')">
            <el-input v-model="ruleForm.nameChina" :disabled="true"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
          <el-form-item
            :label="$t('app.countryDialCode')"
            prop="countryCode"
            ref="countryCode"
          >
            <el-input v-model="ruleForm.countryCode" maxLength="8"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
          <el-form-item
            :label="$t('app.mobilePhoneNumber')"
            prop="tel"
            ref="tel"
          >
            <el-input v-model="ruleForm.tel" maxLength="32"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
          <el-form-item
            :label="$t('app.emailAddress')"
            prop="email"
            ref="email"
          >
            <el-input v-model="ruleForm.email" maxLength="64"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <el-form-item :label="$t('app.applyView.originalInstitution')">
            <el-input
              v-model="ruleForm.school"
              style="width: 100%"
              maxLength="64"
            ></el-input>
          </el-form-item>
        </el-col>
      </div>
      <div class="application-form">
        <h3>{{ $t("app.applicationForAccommodation") }}</h3>
        <el-divider></el-divider>
        <el-form-item
          :label="$t('app.applyView.roomChoose')"
          prop="category"
          ref="category"
        >
          <!-- el-radio-group v-model="ruleForm.category" :disabled="true" -->
          <el-radio-group v-model="ruleForm.category">
            <!-- <el-radio :label="1">{{ $t("app.roomTypeSelect.noI") }}</el-radio>
            <br />
            <el-radio :label="2">{{ $t("app.roomTypeSelect.noII") }}</el-radio>
            <br />
            <el-radio :label="3">{{ $t("app.roomTypeSelect.noIII") }}</el-radio>
            <br />
            <el-radio :label="4">{{$t("app.roomTypeSelect.noIIII")}}</el-radio>
            <br /> -->
            <el-radio :label="5">{{$t("app.roomTypeSelect.noIIIII")}}</el-radio>
            <br />
            <el-radio :label="6">{{$t("app.roomTypeSelect.noIIIIII")}}</el-radio>            
          </el-radio-group>
          <h4>{{ $t("app.roomTypeSelect.remark1") }}</h4>
        </el-form-item>
        <el-form-item
          :label="$t('app.applyView.roommate')"
          prop="roommate"
          ref="roommate"
        >
          <el-radio-group v-model="ruleForm.roommate">
            <el-radio :label="1">{{ $t("app.noSpecialPreference") }}</el-radio>
            <br />
            <el-radio :label="2">{{
              $t("app.studentsFromTheirCountryOrRegion")
            }}</el-radio>
            <br />
            <el-radio :label="3">{{
              $t("app.internationalStudentsFromOtherRegions")
            }}</el-radio>
            <br />
            <el-radio :label="4">{{
              $t("app.exchangeStudentsFromOtherInstitutions")
            }}</el-radio>
            <br />
            <el-radio :label="5">{{
              $t("app.exchangeStudentsFromTheirInstitutions")
            }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="$t('app.applyView.other')">
          <el-input
            type="textarea"
            :autosize="{ minRows: 4 }"
            v-model="ruleForm.other"
            :style="!phoneFlag ? '' : { width: '600px' }"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item
          :label="$t('app.statement')"
          prop="declareCost"
          ref="declareCost"
        >
          <el-checkbox v-model="ruleForm.declareCost">{{
            $t("app.applyView.declareCost")
          }}</el-checkbox>
        </el-form-item> -->

        <div class="date-content">
          <h3>{{ $t("app.arriveInMacau") }}</h3>
          <el-divider></el-divider>
          <ul>
            <li><span style="font-size:13px">• {{ $t("app.arriveInMacauCheckInDesc") }}</span></li>
            <li><span style="font-size:13px">• {{ $t("app.arriveInMacauCheckInDesc2") }}</span></li>
            <li><span>&nbsp;</span></li>
          </ul>
          
          <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
            <el-form-item
              prop="date"
              :label="$t('app.dateOfArrivalInMacao')"
              ref="date"
            >
              <el-date-picker
                type="date"
                value-format="yyyy-MM-dd"
                :placeholder="$t('app.validation.date')"
                v-model="ruleForm.date"
                style="width: 200px"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
            <el-form-item
              prop="time"
              :label="$t('app.timeOfArrivalInMacao')"
              ref="time"
            >
              <el-time-picker
                :placeholder="$t('app.validation.time')"
                value-format="HH:mm"
                v-model="ruleForm.time"
                style="width: 200px"
                format="HH:mm"
              ></el-time-picker>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <el-form-item
              :label="$t('app.portOfArrival')"
              prop="direction"
              ref="direction"
            >
              <el-radio-group v-model="ruleForm.direction">
                <template v-for="p in port">
                  <el-radio :label="p.value" :key="p.value">{{
                    p.label
                  }}</el-radio>
                </template>
              </el-radio-group>
            </el-form-item>
          </el-col>

          <div v-if="ruleForm.direction === 'arrival_air'" style="width: 100%">
            <el-form-item
              :label="$t('app.applyView.departurePort')"
              prop="departurePort"
              ref="departurePort"
            >
              <el-input v-model="ruleForm.departurePort"></el-input>
            </el-form-item>
            <el-form-item
              prop="leaveDate"
              :label="$t('app.applyView.leaveDate')"
              ref="leaveDate"
            >
              <el-date-picker
                type="date"
                value-format="yyyy-MM-dd"
                :placeholder="$t('app.validation.date')"
                v-model="ruleForm.leaveDate"
                style="width: 200px"
              ></el-date-picker>
            </el-form-item>
            <el-form-item
              prop="leaveTime"
              :label="$t('app.applyView.leaveTime')"
              ref="leaveTime"
            >
              <el-time-picker
                :placeholder="$t('app.validation.time')"
                value-format="HH:mm"
                v-model="ruleForm.leaveTime"
                style="width: 200px"
                format="HH:mm"
              ></el-time-picker>
            </el-form-item>
            <el-form-item
              :label="$t('app.applyView.flightNumber')"
              prop="flightNumber"
              ref="flightNumber"
            >
              <el-input v-model="ruleForm.flightNumber"></el-input>
            </el-form-item>
          </div>
          <!-- <el-form-item
            :label="$t('app.applyView.serve') + msg"
            prop="serve"
            ref="serve"
          >
            <el-radio-group v-model="ruleForm.serve">
              <el-radio :label="1">{{ $t("app.applyView.serveI") }}</el-radio>
              <br />
              <el-radio :label="2" :disabled="isNoTime">{{
                $t("app.applyView.serveII")
              }}</el-radio>
            </el-radio-group>
          </el-form-item> -->
          <div class="clearfix"></div>
        </div>

        <el-form-item
          :label="$t('app.statement')"
          prop="declareFinal"
          ref="declareFinal"
        >
          <el-checkbox
            class="phoneCheckbox"
            v-model="ruleForm.declareFinal"
            style="white-space: pre-wrap"
          >
            {{ $t("app.applyView.declareFinal") }}</el-checkbox
          >
        </el-form-item>
        <div :class="[!phoneFlag?'footerFormBar':'']">
          <el-form-item>
            <el-button
              type="primary"
              :loading="submitting"
              :disabled="this.ruleForm.canSubmit"
              @click="submitForm('ruleForm')"
              >{{ $t("app.submit") }}</el-button
            >
            <!-- <el-button size="small" @click="resetForm('ruleForm')">{{
            $t("app.reset")
          }}</el-button> -->
          </el-form-item>
        </div>
      </div>
    </el-form>
  </div>
</template>
<script>
import {
  submit,
  getBaseInfo,
  getDesc,
  getPort,
  dateSupport,
} from "@/api/newStudent";
export default {
  data() {
    var declareCheck = (rule, value, callback) => {
      const that = this;
      if (!value) {
        callback(new Error(that.$t("app.validation.declare")));
      } else {
        callback();
      }
    };
    var dateCheck = (rule, value, callback) => {
      if (this.ruleForm.direction === "arrival_air" && !value) {
        callback(new Error(this.$t("app.validation.date")));
      } else {
        callback();
      }
    };
    var timeCheck = (rule, value, callback) => {
      if (this.ruleForm.direction === "arrival_air" && !value) {
        callback(new Error(this.$t("app.validation.time")));
      } else {
        callback();
      }
    };
    var msgCheck = (rule, value, callback) => {
      if (this.ruleForm.direction === "arrival_air" && !value) {
        callback(new Error(this.$t("app.validation.complete")));
      } else {
        callback();
      }
    };
    return {
      wrapSpan: "",
      phoneFlag: false,
      isNoTime: true,
      port: [],
      msg: "",
      submitting: false,
      ruleForm: {
        departurePortTmp: "",
        leaveDateTmp: "",
        leaveTimeTmp: "",
        flightNumberTmp: "",
        departurePort: "",
        leaveDate: "",
        leaveTime: "",
        flightNumber: "",
        declare: "",
        applyCode: this.$store.state.Config.applicationId,
        gender: "",
        nameFirst: "",
        nameSecond: "",
        nameChina: "",
        countryCode: "",
        tel: "",
        email: "",
        school: "",
        category: "",
        roommate: "",
        declareCost: "",
        declareFinal: "",
        date: "",
        time: "",
        other: "",
        serve: "",
        direction: "",
        canSubmit: true,
      },
      rules: {
        departurePort: [
          { required: true, validator: msgCheck, trigger: "blur" },
        ],
        flightNumber: [
          { required: true, validator: msgCheck, trigger: "blur" },
        ],
        leaveDate: [{ required: true, validator: dateCheck, trigger: "blur" }],
        leaveTime: [{ required: true, validator: timeCheck, trigger: "blur" }],
        declare: [{ required: true, validator: declareCheck, trigger: "blur" }],
        declareCost: [
          { required: true, validator: declareCheck, trigger: "blur" },
        ],
        declareFinal: [
          { required: true, validator: declareCheck, trigger: "blur" },
        ],
        applyCode: [
          {
            required: true,
            message: this.$t("app.validation.applyCode"),
            trigger: "blur",
          },
        ],
        gender: [
          {
            required: true,
            message: this.$t("app.validation.gender"),
            trigger: "blur",
          },
        ],
        nameFirst: [
          {
            required: true,
            message: this.$t("app.validation.surname"),
            trigger: "blur",
          },
        ],
        nameSecond: [
          {
            required: true,
            message: this.$t("app.validation.name"),
            trigger: "blur",
          },
        ],
        countryCode: [
          {
            required: true,
            message: this.$t("app.validation.countryCode"),
            trigger: "blur",
          },
        ],
        tel: [
          {
            required: true,
            message: this.$t("app.validation.tel"),
            trigger: "blur",
          },
        ],
        email: [
          {
            required: true,
            message: this.$t("app.validation.email"),
            trigger: "blur",
          },
        ],
        category: [
          {
            required: true,
            message: this.$t("app.validation.category"),
            trigger: "blur",
          },
        ],
        roommate: [
          {
            required: true,
            message: this.$t("app.validation.roommate"),
            trigger: "blur",
          },
        ],
        serve: [
          {
            required: true,
            message: this.$t("app.validation.serve"),
            trigger: "blur",
          },
        ],
        direction: [
          {
            required: true,
            message: this.$t("app.validation.direction"),
            trigger: "blur",
          },
        ],
        date: [
          {
            required: true,
            message: this.$t("app.validation.date"),
            trigger: "change",
          },
        ],
        time: [
          {
            required: true,
            message: this.$t("app.validation.time"),
            trigger: "change",
          },
        ],
      },
    };
  },
  created() {
    this.phoneFlag = this.$store.state.Config.device;
    getPort().then((res) => {
      this.port = res.data.map((_) => {
        return {
          value: _.DictCode,
          label: _.DictText,
        };
      });
    });
    getDesc().then((res) => {
      this.msg = res.data;
    });
    getBaseInfo({
      applicationCode: this.$store.state.Config.applicationId,
      idNo: this.$store.state.Config.cardId,
    }).then((res) => {
      this.ruleForm.gender = res.data.Gender;
      this.ruleForm.nameFirst = res.data.LastName;
      this.ruleForm.nameSecond = res.data.FirstName;
      this.ruleForm.nameChina = res.data.ChineseName;
      this.ruleForm.countryCode = res.data.NationCode;
      this.ruleForm.tel = res.data.Mobile;
      this.ruleForm.email = res.data.Email;
      this.ruleForm.school = res.data.OriginalSchool;
      this.ruleForm.category = res.data.SelectedRoomType || "5";
      this.ruleForm.roommate = res.data.SelectedRoomMateType;
      this.ruleForm.date = res.data.ArrivalDate || "";
      this.ruleForm.time = res.data.PlanArrivalTime || "";
      this.ruleForm.other = res.data.OtherRequirement;
      this.ruleForm.serve =
        res.data.MeetService === 0 ? 1 : res.data.MeetService;
      this.ruleForm.direction = res.data.MeetAddress;
      this.ruleForm.canSubmit = res.data.IsExpired;
      this.ruleForm.departurePort = res.data.DeparturePort;
      this.ruleForm.leaveDate = res.data.DepartureDate;
      this.ruleForm.leaveTime = res.data.DepartureTime;
      this.ruleForm.flightNumber = res.data.FlightNumber;
      this.ruleForm.departurePortTmp = res.data.DeparturePort;
      this.ruleForm.leaveDateTmp = res.data.DepartureDate;
      this.ruleForm.leaveTimeTmp = res.data.DepartureTime;
      this.ruleForm.flightNumberTmp = res.data.FlightNumber;
    });
  },
  mounted() {
    if (this.$refs.mycolor) {
      this.$refs.mycolor.style.setProperty(
        "--wrapSpan",
        !this.phoneFlag ? "pre-wrap" : ""
      );
    }
  },
  watch: {
    phoneFlag(val, oldVal) {
      this.$el.style.setProperty(
        "--wrapSpan",
        !this.phoneFlag ? "pre-wrap" : ""
      );
    },
    "ruleForm.direction": {
      handler(val) {
        if (val !== "arrival_air") {
          this.ruleForm.departurePort = "";
          this.ruleForm.leaveDate = "";
          this.ruleForm.leaveTime = "";
          this.ruleForm.flightNumber = "";
        } else {
          this.ruleForm.departurePort = this.ruleForm.departurePortTmp;
          this.ruleForm.leaveDate = this.ruleForm.leaveDateTmp;
          this.ruleForm.leaveTime = this.ruleForm.leaveTimeTmp;
          this.ruleForm.flightNumber = this.ruleForm.flightNumberTmp;
        }
      },
      immediate: true,
    },
    isInTime(val) {
      let arr = val.split(",");
      if (arr[0] && arr[1] && arr[2]) {
        dateSupport({
          Date: arr[0],
          Time: arr[1],
          PortCode: arr[2],
        }).then((res) => {
          this.isNoTime = !res.data;
        });
      }
    },
    isNoTime(val) {
      if (val) {
        this.ruleForm.serve = 1;
      }
    },
  },
  computed: {
    isInTime: {
      get() {
        return (
          this.ruleForm.date +
          "," +
          this.ruleForm.time +
          "," +
          this.ruleForm.direction
        );
      },
    },
  },
  methods: {
    submitForm(formName) {
      const that = this;
      this.$refs[formName].validate((valid, object) => {
        if (valid) {
          console.log(valid);
          that.submitting = true;
          submit({
            ApplicationCode: this.valueOrEmpty(this.ruleForm.applyCode),
            Gender: this.ruleForm.gender,
            FirstName: this.valueOrEmpty(this.ruleForm.nameSecond),
            LastName: this.valueOrEmpty(this.ruleForm.nameFirst),
            ChineseName: this.valueOrEmpty(this.ruleForm.nameChina),
            NationCode: this.valueOrEmpty(this.ruleForm.countryCode),
            Mobile: this.valueOrEmpty(this.ruleForm.tel),
            Email: this.valueOrEmpty(this.ruleForm.email),
            OriginalSchool: this.valueOrEmpty(this.ruleForm.school),
            RoomType: this.valueOrEmpty(this.ruleForm.category),
            SelectedRoomType: this.valueOrEmpty(this.ruleForm.category),
            SelectedRoomMateType: this.valueOrEmpty(this.ruleForm.roommate),
            OtherRequirement: this.valueOrEmpty(this.ruleForm.other),
            ArrivalDate: this.valueOrEmpty(this.ruleForm.date),
            PlanArrivalTime: this.valueOrEmpty(this.ruleForm.time),
            MeetService: this.valueOrEmpty(this.ruleForm.serve),
            MeetAddress: this.valueOrEmpty(this.ruleForm.direction),
            DeparturePort: this.valueOrEmpty(this.ruleForm.departurePort),
            DepartureDate: this.valueOrEmpty(this.ruleForm.leaveDate),
            DepartureTime: this.valueOrEmpty(this.ruleForm.leaveTime),
            FlightNumber: this.valueOrEmpty(this.ruleForm.flightNumber),
          })
            .then(() => {
              this.$message({
                message: this.$t("app.opeSuccess"),
                type: "success",
              });
              that.submitting = false;
              this.$router.push("/newStu");
            })
            .catch((error) => {
              console.log(error);
              that.submitting = false;
            });
        } else {
          for (let i in object) {
            let dom = this.$refs[i];
            if (Object.prototype.toString.call(dom) !== "[object Object]") {
              //这里是针对遍历的情况（多个输入框），取值为数组
              dom = dom[0];
            }
            dom.$el.scrollIntoView({
              //滚动到指定节点
              block: "center", //值有start,center,end，nearest，当前显示在视图区域中间
              behavior: "smooth", //值有auto、instant,smooth，缓动动画（当前是慢速的）
            });
            console.log("error submit!!");
            return false;
          }
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    valueOrEmpty(value) {
      return value || "";
    },
  },
};
</script>
<style lang="scss" scoped>
.apply {
  height: calc(100% - 60px);
  overflow: auto;
  .person-info,
  .application-form,
  .date-content {
    background-color: #fff;
    padding: 15px;
    border: solid 1px #ccc;
    border-radius: 5px;
  }
  .person-info {
    overflow: auto;
  }
}
</style>
<style lang="scss" scoped>
.phoneCheckbox {
  ::v-deep .el-checkbox__label {
    display: inline;
  }
}
.apply {
  .person-info,
  .application-form,
  .date-content {
    .el-form-item__content {
      padding: 0 15px;
    }
    .el-input {
      width: 300px;
    }
    .el-radio {
      margin-bottom: 6px;
      display: block;
      white-space: var(--wrapSpan);
    }
  }
}
</style>
